module.exports = __webpack_public_path__ + "static/img/J_hearts.c4ffc70.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cards/J_hearts.svg
// module id = jLL3
// module chunks = 1